import React from 'react';

import { useAppSelector } from '@/redux/store';

import ArenaOfferCard from './ArenaOfferCard';
import BingoEventCard from './BingoEventCard';

// Profit Drop is left out of this version of the shop
const ArenaOffers: React.FC = () => {
  const arenaOffers = useAppSelector((state) => state.shop.arenaOffers);

  return (
    <div className="flex flex-col gap-4">
      <BingoEventCard />
      {arenaOffers.map((el, index) => (
        <ArenaOfferCard key={index} {...el} />
      ))}
    </div>
  );
};

export default ArenaOffers;
